import React, { useState, useEffect } from 'react';
import { Paper, Grid, Avatar, Chip, Typography, InputAdornment, CircularProgress, TextField, IconButton, Card, CardContent, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import SearchIcon from "@mui/icons-material/Search";
import './checklist.css'
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import EmptyState from '../../components/Error/EmptyState';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import CreateTicket from './CreateTicket';
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from 'react-bootstrap';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const MyChecklistItems = (props) => {
	let navigate = useNavigate();
	const [addModal, setAddModal] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [generalModal, setGeneralModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const { id, scheduleId } = useParams();
	const [searchResult, setSearchResult] = useState('');
	const [checklistItems, setChecklistItems] = useState([]);
	const [generalizedTicket, setGeneralizedTicket] = useState(null);
	const [disableItem, setDisableItem] = useState(false);
	const [checklistItemId, setChecklistItemId] = useState('')
	const [scheduleReportId, setScheduleReportId] = useState('')
	const [deleteModal, setDeleteModal] = useState(false)
	const [deleteId, setDeleteId] = useState('')
	const [itemName, setItemName] = useState('')
	const [ticketDetail, setTicketDetail] = useState('')
	const [title, setTitle] = useState('')
	const [status, setStatus] = useState("");
	const [ticketAssigned, setTicketAssigned] = useState('');
	const [locName, setLocName] = useState("");
	const [checkArray , setCheckArray] = useState([]);
	const [expandedRows, setExpandedRows] = useState({});

	const toggleRow = (itemId) => {
		setExpandedRows((prev) => ({
			...prev,
			[itemId]: !prev[itemId],
		}));
	};

	const getChecklistData = () => {
		const body = {
			'checklist_id': id,
			"checklist_schedule_id": scheduleId
		}
		ApiService.post('/checklist/data', body)
			.then((data) => {
				setTitle(data?.title)
				setStatus(data?.schedule?.status || "");
				setTicketAssigned(data?.ticket_assigned_to || "")
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const getGeneralizedTicket = (loader = true) => {
		const body = {
			'checklist_id': id,
			"checklist_schedule_id": scheduleId
		}
		if (loader) {
			setLoading(true)
		}
		ApiService.post('/tickets/checklists/view-genralized-ticket', body)
			.then(({ data }) => {
				setGeneralizedTicket(data)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const getChecklistItems = (loader = true) => {
		const body = {
			'checklist_id': id,
			"checklist_schedule_id": scheduleId,
			"search": searchResult
		}
		if (loader) {
			setLoading(true)
		}
		ApiService.post('/checklist-user/item', body)
			.then(({ data }) => {
				setChecklistItems(data)
				getGeneralizedTicket()
				setLoading(false);

			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const UpdateStatus = (item, status) => {
		const body = {
			'checklist_id': id,
			"checklist_schedule_id": scheduleId,
			"checklist_item_id": item?.id,
			"status": status,
		}
		ApiService.post('/checklist-user/items/status', body)
			.then((data) => {
				toast.success(data?.message)
				getChecklistItems(false)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const RevertStatus = (item, status) => {
		const body = {
			'checklist_id': id,
			"checklist_schedule_id": scheduleId,
			"checklist_item_id": item?.id,
			"status": item?.schedule_reports?.status
		}

		ApiService.post('/checklist-user/revert-status', body)
			.then((data) => {
				toast.success(data?.message)
				getChecklistItems(false)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const Submit = () => {
		const body = {
			'checklist_id': id,
			"checklist_schedule_id": scheduleId,
		}
		ApiService.post('/checklist-user/checklist-schedules/status', body)
			.then((data) => {
				navigate("/firehouse/my-checklist/");
				toast.success(data?.message)
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false)
				if (error.status == 422) {
					Object.keys(error.data.errors).map((err) => (
						toast.error(error.data.errors[err][0])
					))
				}
				else {
					toast.error(error.data.message)
				}
			})
	}

	const deleteItem = () => {
		setLoading(true);
		const body = {
			checklist_ticket_id: deleteId
		}
		ApiService.post('/tickets/checklists/delete', body)
			.then(({ data }) => {
				setDeleteId('')
				setDeleteModal(false)
				getChecklistItems()
				toast.success(data.message)
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
				toast.error(err?.response?.data?.message)
			})
	}

	const viewItem = (id) => {
		const body = {
			checklist_ticket_id: id
		}
		ApiService.post('/tickets/checklists/view-ticket', body)
			.then(({ data }) => {
				setTicketDetail(data)
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
				toast.error(err?.response?.data?.message)
			})
	}

	useEffect(() => {
		getChecklistItems()
		getChecklistData()

	}, [])

	useEffect(() => {
		getChecklistItems(false)
	}, [searchResult])

	const checklistItemsCheck = () => {
		const body = {
			'checklist_id': id,
		}
		ApiService.post('/checklist-user/item-id', body)
			.then((data) => {
				setCheckArray(data?.data || [])
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	useEffect(()=>{
		checklistItemsCheck()
	}, [])



	return (
		<>
			{loading ? (
				<Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
					<CircularProgress />
				</Paper>)
				:
				(<>
					<Paper className="p-4" style={{ marginTop: "1rem" }}>
						<Grid container className='align-items-center' gap={2} fontFamily={'karla'}>

							{/* Heading */}
							<Grid item xs={10} md={9} sx={{ minWidth: '80% !important' }}>
								<Typography variant="h5">
									<Link to="/firehouse/my-checklist" style={{ color: "black" }}>
										<ArrowBackIosIcon />
									</Link>
									{`Checklist > ${title}`}</Typography>  {/* ${(schedules?.title)} */}
							</Grid>

							{/* Search field */}
							<Grid item xs={12} sm={12} md={2}>
								<TextField
									variant="outlined"
									placeholder="Search"
									onChange={(e) => setSearchResult(e.target.value)}
									className="w-100"
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton>
													<SearchIcon />
												</IconButton>
											</InputAdornment>
										),
										sx: {
											height: '48px',
											fontSize: '14px',
										},
									}}
								/>
							</Grid>

							{!checklistItems || checklistItems.length == 0 ?
								<div className='d-flex align-items-center w-100' style={{ height: 550 }}>
									<EmptyState />
								</div>
								:
								<Grid item className='align-items-center p-2' fontFamily={'karla'} md={12}>
									<Card sx={{ backgroundColor: 'rgba(245, 245, 245, 0.4)', border: '1px solid #cccccc', borderRadius: '12px' }} elevation={0}>
										<CardContent>
											<div className='check-items-heading row'>
												<span className='check-items col-md-5'>Checklist Items</span>
												<span className='check-items col-md-3'>Name</span>
												<span className='check-items col-md-2'>{status == "completed" || status == "failed" ? "Status" : "Actions"}</span>
											</div>
											{checklistItems && checklistItems.length > 0 && checklistItems.map((item) => {
												const allItems = item?.location?.all_items || [];
												const filteredItems = allItems.filter(item => !checkArray.includes(item.id));
												const isExpanded = expandedRows[item.id];

												return (
													<>
														<div className='row' style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}>
															<div className='col-md-5 d-flex align-items-center' style={{marginLeft:'10px'}}>
																{filteredItems.length > 0 && (
																	<div onClick={() => toggleRow(item.id)} style={{cursor:'pointer' , marginLeft:'-20px'}}>
																		{isExpanded ? (
																			<ExpandLessIcon/>
																		) : (
																			<ExpandMoreIcon/>
																		)
																		}
																	</div>
																)}
																<span className='col-md-1 d-flex align-items-center' style={{marginLeft:'10px'}}>
																	{item?.location?.type == 'location' ?
																		<img src='/images/Building.png' style={{ width: 30, height: 30 }} />
																		: item?.location?.type == 'location_item' ?
																			<img src="/images/location-item.svg" style={{ width: 23, height: 23 }} />
																			:
																			<img src="/images/location-blue.svg" style={{ width: 25, height: 25 }} />
																	}
																</span>
																<span className='col-md-10 p-0' style={{ color: !item.description ? '#ccc' : 'inherit', pointerEvents: !item.description ? 'none' : 'auto' }}>
																	{item.description || "--"}
																</span>
															</div>
															<div className='col-md-3'>
																<span>
																	{(() => {
																		const desc = item?.item_location?.item?.item_description || item?.location?.location_description;
																		return desc ? desc.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1)) : '';
																	})()}
																</span>
															</div>
															<div className="col-md-2 check-item-card" style={{ gap: 10, justifyContent: 'left' }}>
																{item?.schedule_reports?.status == 'pass' ?
																	<Chip
																		variant="outlined"
																		sx={{
																			backgroundColor: '#DDDDDD00',
																			color: '#2B3F6C',
																			border: '1px solid #2B3F6C80',
																		}}
																		avatar={<Avatar src="/images/check1.png" style={{ width: 30, height: 30, padding: 7 }} />}
																		label={'Passed'}
																	/> :
																	item?.schedule_reports?.status == 'failed' ?
																		item?.schedule_reports?.checklist_ticket_id != null ?
																			<>
																				<Chip
																					variant="outlined"
																					sx={{
																						backgroundColor: '#DDDDDD00',
																						color: '#BF1D2D',
																						border: '1px solid #BF1D2D',
																					}}
																					avatar={<Avatar src="/images/red-cross.png" style={{ width: 24, height: 24, padding: 2 }} />}
																					label={'Failed'}
																				/>
																				<Chip
																					variant="outlined"
																					sx={{
																						backgroundColor: '#EAECF0',
																						color: '#2B3F6C',
																						border: '1px solid #2B3F6C',
																						cursor: 'pointer'
																					}}
																					avatar={<Avatar src="/images/eye.png" style={{ width: 24, height: 24, padding: 2 }} />}
																					label={'View Ticket'}
																					onClick={() => {
																						viewItem(item?.schedule_reports?.checklist_ticket_id)
																						// setTicketDetail(item)
																						setShowModal(true)
																					}}
																				/>
																				{status !== "completed" && status !== "failed" && (
																					<Chip
																						variant="outlined"
																						sx={{
																							backgroundColor: '#0000000D',
																							color: '#000000',
																							border: '1px solid #000000',
																							cursor: 'pointer'
																						}}
																						avatar={<Avatar src="/images/delete1.png" style={{ width: 20, height: 20, padding: 3 }} />}
																						label={'Delete Ticket'}
																						onClick={() => {
																							setDeleteId(item?.schedule_reports?.checklist_ticket_id)
																							setDeleteModal(true)
																						}}
																					/>)}
																			</>
																			:
																			<>
																				<Chip
																					variant="outlined"
																					sx={{
																						backgroundColor: '#DDDDDD00',
																						color: '#BF1D2D',
																						border: '1px solid #BF1D2D',
																					}}
																					avatar={<Avatar src="/images/red-cross.png" style={{ width: 24, height: 24, padding: 3 }} />}
																					label={'Failed'}
																				/>

																				{status !== "completed" && status !== "failed" && (
																					<Chip
																						variant="outlined"
																						sx={
																							{
																								backgroundColor: '#0000000D',
																								color: '#000000',
																								border: '1px solid #000000',
																								cursor: 'pointer'
																							}}
																						avatar={<Avatar src="/images/add.png" style={{ width: 24, height: 24, padding: 3 }} />}
																						label={'Create Ticket'}
																						onClick={() => {
																							setAddModal(true)
																							setDisableItem(false)
																							setChecklistItemId(item?.id)
																							setScheduleReportId(item?.schedule_reports?.id)
																							setItemName(item?.item_location?.item?.item_description)
																							setLocName(item?.location?.location_description)
																						}}
																					/>)}
																			</>
																		:
																		<>
																			<Chip
																				variant="outlined"
																				sx={
																					{
																						backgroundColor: '#DDDDDD00',
																						color: '#BF1D2D',
																						border: '1px solid #BF1D2D',
																						cursor: 'pointer'
																					}}
																				avatar={<Avatar src="/images/red-cross.png" style={{ width: 30, height: 30, padding: 5 }} />}
																				label={'Fail'}
																				onClick={() => UpdateStatus(item, 'failed')}
																			/>
																			<Chip
																				variant="outlined"
																				sx={
																					{
																						backgroundColor: '#DDDDDD00',
																						color: '#2B3F6C',
																						border: '1px solid #2B3F6C80',
																						cursor: 'pointer'
																					}}
																				avatar={<Avatar src="/images/check1.png" style={{ width: 30, height: 30, padding: 7 }} />}
																				label={'Pass'}
																				onClick={() => UpdateStatus(item, 'pass')}
																			/>
																		</>
																}

																{(item?.schedule_reports?.status == 'pass' || item?.schedule_reports?.status == 'failed') && !item?.schedule_reports?.checklist_ticket_id && (status != "completed" && status != "failed") &&
																	<div className="col-md-2 check-item-card" style={{ gap: 10, marginTop: '2px' }}
																		onClick={() => { RevertStatus(item) }}
																	>
																		<img
																			style={{ width: '25px', height: '25px', cursor: 'pointer' }}
																			src="/images/undo.svg"
																		/>
																	</div>}
															</div>
															{isExpanded && (
																<div className="col-md-12 mt-2" style={{ marginLeft: '30px' , paddingTop:'6px' , backgroundColor:'#f5f5f5'  }}>
																	<div style={{marginLeft:'30px'}}>
																		{filteredItems.map(fi => (
																			<div style={{display:'flex' , marginBottom:'4px'}}>
																				<img src='/images/location-blue.svg' style={{ width: 22, height: 22 }}/>
																				<p style={{marginLeft:'10px' , marginBottom:'10px'}}>{fi?.item_description || 'no name'}</p>
																			</div>
																		))}
																	</div>
																</div>
															)}
														</div>
													</>
												)
											})}
										</CardContent>
									</Card>

									<Grid container gap={2} className='justify-content-end'>

										{/* Create Generalize Ticket Button */}
										{(!generalizedTicket || generalizedTicket == null) ?
											<Grid item xs={6} md={'auto'} className='btn-check-2'>
												<ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'
													disabled={status == "completed" || status == "failed"}
													onClick={() => {
														setAddModal(true)
														setDisableItem(true)
														setItemName('')
														setLocName('')
													}}>
													Create Generalize Ticket
												</ButtonTheme>
											</Grid>
											:
											<>
												<Grid item xs={6} md={'auto'}
													onClick={() => { setGeneralModal(true) }}>
													<ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'>
														View Ticket
													</ButtonTheme>
												</Grid>

												<Grid item xs={6} md={'auto'}>
													<ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'
														disabled={status == "completed" || status == "failed"}
														onClick={() => {
															setDeleteId(generalizedTicket?.id)
															setDeleteModal(true)
														}}>
														Delete Ticket
													</ButtonTheme>
												</Grid>
											</>
										}

										{/* Submit Button */}
										<Grid item xs={6} md={'auto'}>
											<ButtonTheme type='submit' variant="filled" color='primary' className='px-4 mt-4'
												disabled={!checklistItems || !checklistItems.length > 0 || checklistItems.find((a) => a.schedule_reports == null) || status == "completed" || status == "failed"}
												onClick={() => Submit()}>
												Submit
											</ButtonTheme>
										</Grid>

									</Grid>
								</Grid>
							}
						</Grid>
					</Paper >

					{addModal &&
						<CreateTicket addModal={addModal} setAddModal={setAddModal} scheduleReportId={scheduleReportId}
							disableItem={disableItem} checklistItemId={checklistItemId} getChecklistItems={getChecklistItems}
							itemName={itemName} locName={locName} ticketAssigned={ticketAssigned} />
					}
				</>)}

			{/* View Ticket Pop-Up View */}
			<div className='font-fam'>
				<Modal className='checklist-modal' show={showModal} size="md" onHide={() => {
					setShowModal(false)
				}}>
					<Modal.Header closeButton>
						<Modal.Title>View Ticket</Modal.Title>
					</Modal.Header>
					<div className='ticket-item-heading'>{ticketDetail?.title}</div>
					<Modal.Body >
						<Grid item xs={12} sm={6} md={6}>
							<div className='font-fam model-bg'>

								<div >
									<div className='ticket-margin row'>
										<div className='ticket-item'>{ticketDetail?.checklist_item?.location?.type == "location_item" ? "Location & Item :" : ticketDetail?.checklist_item?.location?.type == "location" ? "Location :" : "Item :"} {ticketDetail?.checklist_item?.location?.location_description || ticketDetail?.checklist_item?.item_location?.item?.item_description} </div>
										<div className='ticket-todo'>{ticketDetail?.tickteting_status?.status &&
											ticketDetail.tickteting_status.status.charAt(0).toUpperCase() +
											ticketDetail.tickteting_status.status.slice(1)}</div>
									</div>

									<div className='ticket-margin row'>
										<div style={{ color: '#000' }}>Assign To : <span style={{ color: '#555555' }}>{ticketDetail?.employee_first_name ? ticketDetail?.employee_first_name + ' ' + ticketDetail?.employee_last_name : 'Unassigned'}</span> </div>
									</div>
									{/* 
									<div className='ticket-margin row'>
										<div style={{ color: '#000' }}>Notify To : <span style={{ color: '#555555' }}>{ticketDetail?.notify_employee_first_name + ' ' + ticketDetail?.notify_employee_last_name || 'Unassigned'}</span> </div>
									</div> */}

									<div className="col-md-7 mt-1">
										<Typography variant="h6">
											Description
										</Typography>
									</div>

									<div className='row'>
										<div className='col' style={{ color: '#555555' }}>{ticketDetail?.description}</div>
									</div>

									<div className='row mt-2'>
										<div className='col'>
											<Typography variant="h6">
												Image
											</Typography>
											{ticketDetail?.image || ticketDetail?.secondary_image ? (
												<>
													{ticketDetail?.image != null &&
														<img src={ticketDetail?.image} width='100px' height='100px' style={{ marginTop: '10px', marginRight: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
													}
													{ticketDetail?.secondary_image != null &&
														<img src={ticketDetail?.secondary_image} width='100px' height='100px' style={{ marginTop: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
													}
												</>
											) :
												<p>No Image Uploaded</p>
											}
										</div>

									</div>
								</div>
							</div>
						</Grid>
					</Modal.Body>
				</Modal>
			</div >

			{/* View Ticket Generalized Pop-Up View */}
			< div className='font-fam' >
				<Modal className='checklist-modal' show={generalModal} size="md" onHide={() => {
					setGeneralModal(false)
				}}>
					<Modal.Header closeButton>
						<Modal.Title>View Generalized Ticket</Modal.Title>
					</Modal.Header>
					<div className='ticket-item-heading'>{generalizedTicket?.title}</div>
					<Modal.Body >
						<Grid item xs={12} sm={6} md={6}>
							<div className='font-fam model-bg'>

								<div >
									<div className='ticket-margin row'>
										<div className='ticket-item'>Generalized Ticket </div>
										<div className='ticket-todo'>{generalizedTicket?.tickteting_status?.status &&
											generalizedTicket.tickteting_status.status.charAt(0).toUpperCase() +
											generalizedTicket.tickteting_status.status.slice(1)}</div>
									</div>

									<div className='ticket-margin row'>
										<div style={{ color: '#000' }}>Assign To : <span style={{ color: '#555555' }}>{generalizedTicket?.employee_first_name ? generalizedTicket?.employee_first_name + ' ' + generalizedTicket?.employee_last_name : "Unassigned"}</span> </div>
									</div>

									{/* <div className='ticket-margin row'>
										<div style={{ color: '#000' }}>Notify To : <span style={{ color: '#555555' }}>{generalizedTicket?.notify_employee_first_name + ' ' + generalizedTicket?.notify_employee_last_name}</span> </div>
									</div> */}

									<div className="col-md-7 mt-1">
										<Typography variant="h6">
											Description
										</Typography>
									</div>

									<div className='row'>
										<div className='col' style={{ color: '#555555' }}>{generalizedTicket?.description}</div>
									</div>

									<div className='row mt-2'>
										<div className='col'>
											<Typography variant="h6">
												Image
											</Typography>
											{generalizedTicket?.image || generalizedTicket?.secondary_image ? (
												<>
													{generalizedTicket?.image != null &&
														<img src={generalizedTicket?.image} width='100px' height='100px' style={{ marginTop: '10px', marginRight: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
													}
													{generalizedTicket?.secondary_image != null &&
														<img src={generalizedTicket?.secondary_image} width='100px' height='100px' style={{ marginTop: '10px', borderRadius: '8px', border: '1px solid #cccccc' }} />
													}
												</>
											) :
												<p>No Image Uploaded</p>
											}
										</div>
									</div>
								</div>
							</div>

						</Grid>
					</Modal.Body>
				</Modal>
			</div >

			{/* Delete Ticket Pop-Up View */}
			< div className='font-fam' >
				<Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
					<Modal.Header closeButton>

						<Modal.Title>Delete Checklist Item</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<div style={{ color: '#555555' }}>
							Are you sure you want to delete this ticket?
						</div>
						<Row>
							<Col md='auto'>
								<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
									setDeleteModal(false)
								}}>
									Cancel
								</ButtonTheme>
							</Col>
							<Col md='auto'>
								<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={deleteItem}>
									Delete
								</ButtonTheme>
							</Col>
						</Row>
					</Modal.Body>
				</Modal>
			</div >
		</>
	)
}
export default MyChecklistItems
